module.exports = __webpack_public_path__ + "static/media/7_disco_68.7_88.61.fca89556.png";